import { Box, Typography } from "@mui/material";

export const OverviewTimesheet = ({timesheetStatuses}) => {

  // Find the maximum total_hours to scale the bars dynamically
  const maxHours = Math.max(...timesheetStatuses.map((item) => item.total_hours), 0);

  // const maxHours = Math.max(...timesheetStatuses.map((item) => item.total_hours), 0);
    // Generate axis labels
    // const axisSteps = 40; // Number of steps in the axis
    // const axisLabels = Array.from({ length: axisSteps + 1 }, (_, i) =>
    //   Math.round((maxHours / axisSteps) * i)
    // );
    const stepSize = 20; // Set the interval for labels
    const axisLabels = Array.from(
      { length: Math.ceil(maxHours / stepSize) + 1 },
      (_, i) => i * stepSize
    );
  return (
    // <Box sx={{ padding: "20px" }}>
    //   <Typography variant="h6" gutterBottom>
    //     Timesheet
    //   </Typography>
    //   <Box>
    //     {timesheetStatuses.map((item, index) => (
    //       <Box
    //         key={index}
    //         sx={{
    //           display: "flex",
    //           alignItems: "center",
    //           marginBottom: "15px",
    //         }}
    //       >
    //         <Typography
    //           sx={{
    //             width: "150px",
    //             fontSize: "14px",
    //             marginRight: "10px",
    //           }}
    //         >
    //           {item.project_name}
    //         </Typography>
    //         <Box
    //           sx={{
    //             flexGrow: 1,
    //             height: "20px",
    //             backgroundColor: "#e0f7fa",
    //             position: "relative",
    //           }}
    //         >
    //           <Box
    //             sx={{
    //               width: `${(item.total_hours / maxHours) * 100}%`,
    //               height: "100%",
    //               backgroundColor: "#00796b",
    //              borderRadius: '10px'
    //             }}
    //           />
    //         </Box>
    //         <Typography
    //           sx={{
    //             marginLeft: "10px",
    //             fontSize: "14px",
    //           }}
    //         >
    //           {item.total_hours.toFixed(2)} hrs
    //         </Typography>
    //       </Box>
    //     ))}
    //   </Box>
    // </Box>
  //   <Box sx={{ padding: "20px" }}>
  //   <Typography variant="h6" gutterBottom>
  //     Timesheet
  //   </Typography>
  //   <Box>
  //     {timesheetStatuses.map((item, index) => (
  //       <Box
  //         key={index}
  //         sx={{
  //           display: "flex",
  //           alignItems: "center",
  //           marginBottom: "10px",
  //         }}
  //       >
  //         <Typography
  //           sx={{
  //             width: "150px",
  //             fontSize: "14px",
  //             marginRight: "10px",
  //           }}
  //         >
  //           {item.project_name}
  //         </Typography>
  //         <Box
  //           sx={{
  //             flexGrow: 1,
  //             height: "20px",
  //             backgroundColor: "#e0f7fa",
  //             position: "relative",
  //           }}
  //         >
  //           <Box
  //             sx={{
  //               width: `${(item.total_hours / maxHours) * 100}%`,
  //               height: "100%",
  //               backgroundColor: "#00796b",
  //             }}
  //           />
  //         </Box>
  //         <Typography
  //           sx={{
  //             marginLeft: "10px",
  //             fontSize: "14px",
  //           }}
  //         >
  //           {item.total_hours.toFixed(2)} hrs
  //         </Typography>
  //       </Box>
  //     ))}
  //   </Box>

  //   {/* Axis Labels */}
  //   <Box
  //     sx={{
  //       marginTop: "20px",
  //       position: "relative",
  //     }}
  //   >
  //     <Box
  //       sx={{
  //         height: "2px",
  //         backgroundColor: "#bdbdbd",
  //         position: "absolute",
  //         width: "100%",
  //       }}
  //     ></Box>
  //     <Box
  //       sx={{
  //         display: "flex",
  //         justifyContent: "space-between",
  //         position: "relative",
  //         marginTop: "10px",
  //       }}
  //     >
  //       {axisLabels.map((label, index) => (
  //         <Typography
  //           key={index}
  //           sx={{
  //             fontSize: "12px",
  //           }}
  //         >
  //           {label}
  //         </Typography>
  //       ))}
  //     </Box>
  //   </Box>
  // </Box>
  <Box sx={{ padding: "20px" }} className="mt-4">
  
  <Box sx={{ display: "flex", alignItems: "flex-start" }}>
    {/* Project Names */}
    <Box
      sx={{
        width: "150px",
        display: "flex",
        flexDirection: "column",
        marginRight: "20px", // Adds spacing between names and graph
      }}
    >
      {timesheetStatuses.map((item, index) => (
        <Typography
          key={index}
          sx={{
            fontSize: "14px",
            marginBottom: "35px",
            textAlign: "right",
           
          }}
        >
          {item.project_name}
        </Typography>
      ))}
    </Box>

    {/* Graph and Bars */}
    <Box sx={{ flexGrow: 1, position: "relative" }}>
      {/* Bars */}
      <Box>
        {timesheetStatuses.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "35px",
            }}
          >
            <Box
              sx={{
                height: "20px",
                width: "100%",
                backgroundColor: "#e0f7fa",
                position: "relative",
                borderRadius: "10px"
              }}
            >
              <Box
                sx={{
                  width: `${(item.total_hours / maxHours) * 100}%`,
                  height: "100%",
                  backgroundColor: "#00796b",
                  borderRadius: "10px"
                }}
              />
            </Box>
            <Typography
              sx={{
                marginLeft: "10px",
                fontSize: "14px",
              }}
            >
              {item.total_hours.toFixed(2)} 
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Axis Labels */}
      <Box
        sx={{
          position: "absolute",
          bottom: "-30px",
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {axisLabels.map((label, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: "12px",
              transform: "translateX(-50%)",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Typography>
        ))}
      </Box>

      {/* Horizontal Line */}
      <Box
        sx={{
          position: "absolute",
          bottom: "-10px",
          left: 0,
          width: "100%",
          height: "2px",
          backgroundColor: "#bdbdbd",
        }}
      />
    </Box>
  </Box>
</Box>
  );
};


